import React from 'react';
import styles from './RecognitionSection.module.css';
import { FaTerminal } from 'react-icons/fa';
import { isSmallScreen } from '../../../utils/screen';

interface RecognitionSectionProps {
  title: React.ReactNode;
  subtitle: Array<React.ReactNode>;
  recognitionImage: string;
  speakerImage?: string;
}

const RecognitionSection: React.FC<RecognitionSectionProps> = ({
  title,
  subtitle,
  recognitionImage,
  speakerImage
}) => {
  // Determine if we should use single image layout
  const isSingleImage = !speakerImage;
  
  return (
    <section className={`${styles.recognitionSection} ${isSingleImage ? styles.singleImageSection : ''}`}>
      <div className={`${styles.rowContainer} ${isSingleImage ? styles.singleImageLayout : ''}`}>
        <div className={`${isSingleImage ? styles.singleImageContainer : styles.imagesContainer}`}>
          <div className={`${styles.leftImageContainer} ${isSingleImage ? styles.singleImage : ''}`}>
            <img 
              src={recognitionImage} 
              alt="Recognition" 
              loading="lazy"
              width={isSingleImage ? "800" : "500"}
              height={isSingleImage ? "500" : "400"}
              className={isSingleImage ? styles.singleImageFile : ''}
            />
          </div>
          {speakerImage && (
            <div className={styles.rightImageContainer}>
              <img 
                src={speakerImage} 
                alt="Speaker" 
                loading="lazy"
              />
            </div>
          )}
        </div>
        <div className={`${styles.rowContainerTitle} ${isSingleImage ? styles.singleImageText : ''}`}>
          <FaTerminal size={isSmallScreen() ? 44 : 54} />
          <div className={styles.recognitionHeader}>
            <h2 className={styles.sectionTitle}>
              {title}
            </h2>
            {subtitle.map((item, index) => (
              <p key={index} className={styles.sectionSubtitle}>
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecognitionSection; 